(() => {
  if (customElements.get('yh-store-reviews')) return;
  class YiyaeStoreReviews extends HTMLElement {
    async connectedCallback() {
      if (this.controller) return;
      const controller = this.controller = new AbortController();
      this.q = selector => this.querySelector(selector);
      this.state = { photos: false, sort: 'mixed', limit: 6 };
      // Shopify form feedback must stay available independently of the review feed.
      this.addEventListener('click', event => {
        if (event.target.closest('[data-compose]')) this.q('[data-compose-dialog]').showModal();
        const close = event.target.closest('[data-close]');
        if (close) this.q(`[data-${close.dataset.close}-dialog]`)?.close();
      }, { signal: controller.signal });
      if (this.q('[data-form-open]')) this.q('[data-compose-dialog]').showModal();
      try {
        this.labels = JSON.parse(this.q('[data-review-labels]').textContent);
        this.core = await import(this.dataset.coreUrl);
        let source = JSON.parse(this.q('[data-review-source]').textContent);
        if (!source && this.dataset.showDemo === 'true') {
          const response = await fetch(this.dataset.demoUrl, { signal: controller.signal });
          if (!response.ok) throw new Error('Review data unavailable');
          source = await response.json();
        }
        if (controller.signal.aborted || !this.isConnected) return;
        this.rows = this.core.normalizeReviews(Array.isArray(source) ? source : source?.reviews);
        this.isDemo = Boolean(source?.isDemo || this.rows.some(row => row.isDemo));
        if (this.isDemo) this.rows = this.rows.map(row => ({ ...row, isDemo: true }));
        this.totals = this.core.summarize(this.rows);
        this.q('[data-review-notice]').hidden = !this.isDemo;
        this.q('[data-review-overview]').innerHTML = this.core.renderOverview(this.totals, this.labels);
        this.q('[data-review-toolbar]').hidden = !this.totals.count;
        this.q('[data-all-count]').textContent = this.totals.count;
        this.q('[data-photo-count]').textContent = this.rows.filter(row => row.photos.length).length;
        this.q('[data-filter="photos"]').hidden = !this.rows.some(row => row.photos.length);
        document.querySelectorAll('[data-yh-store-rating]').forEach(mount => {
          mount.innerHTML = this.core.renderSnippet(this.totals, this.labels, '#' + this.id, this.isDemo);
          mount.hidden = !this.totals.count;
        });
        this.addEventListener('click', event => this.onClick(event), { signal: controller.signal });
        this.q('[data-sort]').addEventListener('change', event => {
          this.state.sort = event.target.value;
          this.state.limit = 6;
          this.render();
        }, { signal: controller.signal });
        this.observer = new ResizeObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.positionCards());
        });
        this.render();
        this.dataset.status = 'ready';
      } catch (error) {
        if (controller.signal.aborted) return;
        this.dataset.status = 'error';
        const message = document.createElement('p');
        message.textContent = this.labels?.load_error || 'Reviews could not be loaded.';
        message.setAttribute('role', 'status');
        this.q('[data-review-overview]').replaceChildren(message);
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    positionCards() {
      const list = this.q('[data-review-list]');
      const cards = [...list.querySelectorAll('.review-card')];
      if (!cards.length) { delete list.dataset.layout; list.style.height = ''; return; }
      list.dataset.layout = 'masonry';
      const style = getComputedStyle(list);
      const columns = Number(style.getPropertyValue('--review-columns')) || 2;
      const gap = parseFloat(style.getPropertyValue('--review-gap')) || 14;
      const heights = cards.map(card => card.getBoundingClientRect().height);
      const signature = [list.clientWidth, columns, gap, ...heights].join(',');
      if (signature === this.layoutSignature) return;
      this.layoutSignature = signature;
      const layout = this.core.layoutCards(heights, columns, gap);
      cards.forEach((card, index) => {
        const position = layout.positions[index];
        card.style.top = position.top + 'px';
        card.style.left = `calc(${position.column} * (100% + var(--review-gap)) / var(--review-columns))`;
      });
      list.style.height = layout.height + 'px';
    }

    render() {
      const filtered = this.core.selectReviews(this.rows, this.state);
      this.q('[data-results-count]').textContent = `${filtered.length} ${filtered.length === 1 ? this.labels.review_one : this.labels.review_many}`;
      this.q('[data-clear]').hidden = !this.state.photos;
      this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.filter === 'photos') === this.state.photos)));
      const list = this.q('[data-review-list]');
      list.innerHTML = filtered.length
        ? filtered.slice(0, this.state.limit).map(row => this.core.renderCard(row, this.labels)).join('')
        : this.totals.count ? `<div class="empty"><h2>${this.core.escape(this.labels.none_title)}</h2><button type="button" data-clear>${this.core.escape(this.labels.reset)}</button></div>` : '';
      this.q('[data-more]').hidden = this.state.limit >= filtered.length;
      this.layoutSignature = '';
      this.observer?.disconnect();
      this.positionCards();
      this.observer?.observe(list);
      list.querySelectorAll('.review-card').forEach(card => this.observer?.observe(card));
    }

    onClick(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-filter')) {
        this.state.photos = button.dataset.filter === 'photos'; this.state.limit = 6; this.render();
      } else if (button.hasAttribute('data-clear')) {
        this.state.photos = false; this.state.limit = 6; this.render();
      } else if (button.hasAttribute('data-more')) {
        this.state.limit += 6; this.render();
      }
    }
  }
  customElements.define('yh-store-reviews', YiyaeStoreReviews);
})();
